<template>
  <div class="simple-refund-page">
    <faturacomp ref="faturacomp" v-model="FaturaComp"></faturacomp>
    <snackbarcomp :mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>

    <v-form class="refund-form">
      <section class="refund-hero">
        <div>
          <span class="refund-badge">{{ $t('Simple-Ticket-Refund') }}</span>
          <h1>{{ $t('Ticket-Refund') }}</h1>
          <p v-if="BiletIade.GenelBilgileri.BiletNo">
            {{ BiletIade.GenelBilgileri.HavaYoluKodu }} · {{ BiletIade.GenelBilgileri.BiletNo }}
          </p>
        </div>

        <div class="hero-actions">
          <v-btn
            v-if="!iadeiptalbtn"
            class="primary-action"
            :disabled="loadingdialogkayit"
            depressed
            @click="iadekaydet()"
          >
            {{ $t('Save-Refund') }}
            <v-icon right>save</v-icon>
          </v-btn>

          <v-btn
            v-else
            class="primary-action"
            :disabled="loadingdialogkayit"
            depressed
            @click="iadekaydet()"
          >
            {{ $t('Update-Refund') }}
            <v-icon right>edit</v-icon>
          </v-btn>

          <v-menu offset-y left>
            <v-btn slot="activator" class="more-action" depressed icon>
              <v-icon>more_vert</v-icon>
            </v-btn>

            <v-list>
              <v-list-tile :disabled="iadefaturami" @click="iadeFaturala()">
                <v-list-tile-title>{{ $t('Refund-Invoice') }}</v-list-tile-title>
              </v-list-tile>

              <v-list-tile v-if="iadeiptalbtn" @click="iadeiptal()">
                <v-list-tile-title>{{ $t('Delete-Return') }}</v-list-tile-title>
              </v-list-tile>

              <v-list-tile v-if="yeniiadebtn" @click="yeniiadeekle()">
                <v-list-tile-title>{{ $t('Add-New-Return') }}</v-list-tile-title>
              </v-list-tile>

              <v-divider></v-divider>

              <v-list-tile @click="sayfakapatiade()">
                <v-list-tile-title>{{ $t('cancel_button') }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </section>

      <v-container fluid class="refund-content">
        <v-layout row wrap>
          <v-flex xs12 lg8 class="content-column">
            <v-card class="modern-card" flat>
              <div class="card-heading">
                <span class="heading-icon">
                  <v-icon>assignment_return</v-icon>
                </span>

                <div>
                  <h2>{{ $t('Refund-Information') }}</h2>
                  <p>{{ $t('Ticket-Information') }}</p>
                </div>
              </div>

              <v-layout row wrap class="field-grid">
                <v-flex xs12 sm6 md4>
                  <tarihcomp
                    :etiket="$t('Refund-Date')"
                    :tabindex="'1'"
                    :defaultvalue="'ok'"
                    v-model="BiletIade.TarihBilgileri.IadeTarihi"
                  ></tarihcomp>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <tarihcomp
                    :etiket="$t('Expiry-Return')"
                    :tabindex="'2'"
                    :defaultvalue="'ok'"
                    v-model="BiletIade.TarihBilgileri.VadeTarihi"
                  ></tarihcomp>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <tarihcomp
                    :etiket="$t('Refund-Invoice-Date')"
                    :tabindex="'3'"
                    :defaultvalue="'ok'"
                    v-model="BiletIade.TarihBilgileri.IadeFaturaTarihi"
                  ></tarihcomp>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="BiletIade.FaturaBilgileri.IadeFaturaGelenBelgeNo"
                    :label="$t('Refund-Invoice-Document-No')"
                    hide-details
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="BiletIade.FaturaBilgileri.DekontNo"
                    :label="$t('Refund-Receipt-No')"
                    mask="####################"
                    hide-details
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <kesenkisi
                    :etiket="$t('Person-Accepting-the-Refund')"
                    v-model="BiletIade.GenelBilgileri.KesenKisi"
                  ></kesenkisi>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="BiletIade.FaturaBilgileri.ServisFaturaNo"
                    :label="$t('Service-Invoice-No')"
                    hide-details
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md4 class="checkbox-field">
                  <v-checkbox
                    v-model="BiletIade.OdemeBilgileri.Odeme"
                    :label="$t('Payment-made')"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-flex>

                <v-flex xs12 md4>
                  <div class="option-box receipt-option-box">
                    <div class="option-title">
                      {{ $t('Receipt-Note-of-Expenses') }}
                    </div>

                    <v-radio-group
                      v-model="BiletIade.DigerBilgileri.DekontPusula"
                      row
                      hide-details
                    >
                      <v-radio
                        :label="$t('Print-Receipt')"
                        value="D"
                        color="primary"
                      ></v-radio>

                      <v-radio
                        :label="$t('Print-Note-of-Expenses')"
                        value="P"
                        color="primary"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-flex>

                <v-flex xs12>
                  <v-textarea
                    v-model="BiletIade.GenelBilgileri.Notlar"
                    :label="$t('Notes')"
                    rows="2"
                    auto-grow
                    hide-details
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-card>

            <v-card class="modern-card" flat>
              <div class="card-heading">
                <span class="heading-icon route-icon">
                  <v-icon>flight_takeoff</v-icon>
                </span>

                <div>
                  <h2>{{ $t('Flight-and-Route-Information') }}</h2>
                  <p>{{ $t('Refund-Options') }}</p>
                </div>
              </div>

              <v-layout row wrap class="field-grid route-grid">
                <v-flex
                  v-for="index in 5"
                  :key="index"
                  xs12
                  sm6
                  md4
                >
                  <v-text-field
                    v-model="BiletIade.GenelBilgileri.Parkurlar['Parkur' + index]"
                    :label="$t('Route') + ' ' + index"
                    hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="option-grid">
                <v-flex xs12>
                  <div class="option-box">
                    <div class="option-title">
                      {{ $t('Refunded-Flight') }}
                    </div>

                    <v-radio-group
                      v-model="BiletIade.GenelBilgileri.IadeUcusTip"
                      row
                      hide-details
                    >
                      <v-radio
                        :label="$t('Departure')"
                        value="G"
                        color="primary"
                      ></v-radio>

                      <v-radio
                        :label="$t('Return')"
                        value="D"
                        color="primary"
                      ></v-radio>

                      <v-radio
                        :label="$t('Complete')"
                        value="T"
                        color="primary"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 lg4 class="summary-column">
            <v-card class="modern-card summary-card" flat>
              <div class="card-heading">
                <span class="heading-icon amount-icon">
                  <v-icon>account_balance_wallet</v-icon>
                </span>

                <div>
                  <h2>{{ $t('Refund-Amount-Details') }}</h2>
                  <p>{{ $t('Refund-Summary') }}</p>
                </div>
              </div>

              <div class="total-panel">
                <span>{{ $t('Refund-Total') }}</span>

                <strong>
                  {{ formatRefundAmount(BiletIade.TutarBilgileri.NetTutar.NetTutar) }}
                </strong>

                <small>
                  {{ BiletIade.TutarBilgileri.Doviz.DovizKod || getparabirimi() }}
                </small>
              </div>

              <div class="amount-fields">
                <parainput
                  :isPositive="true"
                  :simge="getparabirimi()"
                  :etiket="$t('Amount-Without-Penalty')"
                  :aktif="'true'"
                  v-model="BiletIade.CezasızTutar"
                  :autocomplete="'autocomplete'"
                ></parainput>

                <parainput
                  :isPositive="true"
                  :simge="getparabirimi()"
                  :etiket="$t('Amount')"
                  v-model="BiletIade.TutarBilgileri.Tutar.Tutar"
                  :autocomplete="'autocomplete'"
                ></parainput>

                <parainput
                  :isPositive="true"
                  :simge="getparabirimi()"
                  :etiket="$t('Penalty')"
                  v-model="BiletIade.TutarBilgileri.CezaTutar.CezaTutar"
                  :autocomplete="'autocomplete'"
                ></parainput>

                <parainput
                  v-if="icHat"
                  :isPositive="true"
                  :simge="getparabirimi()"
                  :etiket="$t('Landing-Tax')"
                  v-model="BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiTutar"
                  :autocomplete="'autocomplete'"
                ></parainput>

                <parainput
                  :isPositive="true"
                  :simge="getparabirimi()"
                  :etiket="$t('Tax-Amount')"
                  :aktif="icHat"
                  v-model="BiletIade.TutarBilgileri.TaxTutar.TaxTutar"
                  :autocomplete="'autocomplete'"
                ></parainput>

                <parainput
                  :isPositive="true"
                  :simge="getparabirimi()"
                  :etiket="$t('Fuel-Price-Difference')"
                  v-model="BiletIade.TutarBilgileri.YffTutar.YFFTutar"
                  :autocomplete="'autocomplete'"
                ></parainput>

                <parainput
                  :isPositive="true"
                  :simge="getparabirimi()"
                  :etiket="$t('Refund-Service-Fee')"
                  v-model="BiletIade.TutarBilgileri.IadeServisTutar.IadeServisTutar"
                  :autocomplete="'autocomplete'"
                ></parainput>

                <parainput
                  :isPositive="true"
                  :simge="getparabirimi()"
                  :etiket="$t('KA-Tax')"
                  v-model="BiletIade.TutarBilgileri.KaTutar.KaTutar"
                  :autocomplete="'autocomplete'"
                ></parainput>

                <parainput
                  :isPositive="true"
                  :simge="getparabirimi()"
                  :aktif="iadefaturami"
                  :etiket="$t('Service-Fee')"
                  v-model="BiletIade.TutarBilgileri.ServisTutar.ServisTutar"
                  :autocomplete="'autocomplete'"
                ></parainput>

                <parainput
                  :isPositive="true"
                  :simge="getparabirimi()"
                  :etiket="$t('Discount-Amount')"
                  v-model="BiletIade.TutarBilgileri.IskontoTutar.IskontoTutar"
                  :autocomplete="'autocomplete'"
                ></parainput>

                <parainput
                  :isPositive="true"
                  :simge="getparabirimi()"
                  :etiket="$t('Other-Service-Amount')"
                  v-model="BiletIade.TutarBilgileri.DigerServisTutar.DigerServisTutar"
                  :autocomplete="'autocomplete'"
                ></parainput>

                <parainput
                  :isPositive="true"
                  :simge="getparabirimi()"
                  :etiket="reserveName"
                  v-model="BiletIade.TutarBilgileri.ReserveTutar.ReserveTutar"
                  :autocomplete="'autocomplete'"
                ></parainput>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>

    <v-dialog v-model="dialogkisamesaj" width="500">
      <v-card>
        <v-card-title class="headline">
          {{ $t('Warning') }}!
        </v-card-title>

        <v-card-text>
          {{ kisamesaj }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            flat
            @click="dialogkisamesaj = false"
          >
            {{ $t('OK') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loadingdialogkayit"
      hide-overlay
      persistent
      width="400"
    >
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t('Processing-please-wait') }} ...

          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loadingdialog"
      hide-overlay
      persistent
      width="400"
    >
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t('Preparing-ticket-please-wait') }} ...

          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BiletIadeBase from './biletiade.vue'
import helpers from '@/components/app/customcomp/helpers.js'

export default {
  extends: BiletIadeBase,

  created() {
    this.simpleRefundOriginalPageScreenAuth = helpers.pageScreenAuth

    helpers.pageScreenAuth = function () {
      return {
        Screen: true,
        Update: true,
        Save: true,
        Delete: true,
        Status: true,
        Message: null,
        islem: 0
      }
    }
  },

  mounted() {
    if (this.simpleRefundOriginalPageScreenAuth) {
      helpers.pageScreenAuth = this.simpleRefundOriginalPageScreenAuth
    }
  },

  beforeDestroy() {
    if (this.simpleRefundOriginalPageScreenAuth) {
      helpers.pageScreenAuth = this.simpleRefundOriginalPageScreenAuth
    }
  },

  methods: {
    formatRefundAmount(value) {
      var amount = Number(value || 0)

      return amount.toLocaleString('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }
  }
}
</script>

<style scoped>
.simple-refund-page {
  min-height: 100vh;
  background: #f3f6fb;
  color: #15233c;
}

.refund-form {
  min-height: 100vh;
}

.refund-hero {
  margin: 20px 24px 0;
  padding: 27px 30px;
  border-radius: 24px;
  background: linear-gradient(
    120deg,
    #102653 0%,
    #1746a2 54%,
    #1697e8 100%
  );
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 18px 40px rgba(25, 70, 150, 0.2);
}

.refund-hero h1 {
  margin: 9px 0 3px;
  font-size: 30px;
  font-weight: 700;
}

.refund-hero p {
  margin: 0;
  color: rgba(255, 255, 255, 0.75);
  font-size: 14px;
}

.refund-badge {
  display: inline-flex;
  padding: 6px 12px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 12px;
  font-weight: 600;
}

.hero-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.primary-action {
  min-width: 150px;
  border-radius: 18px !important;
  background: #fff !important;
  color: #153a80 !important;
  font-weight: 700;
  text-transform: none;
}

.more-action {
  background: rgba(255, 255, 255, 0.94) !important;
  color: #153a80 !important;
}

.refund-content {
  padding: 16px 16px 28px;
}

.content-column,
.summary-column {
  padding: 8px;
}

.modern-card {
  margin-bottom: 16px;
  padding: 23px;
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 10px 32px rgba(24, 48, 85, 0.07) !important;
}

.card-heading {
  display: flex;
  align-items: center;
  gap: 13px;
  margin-bottom: 17px;
}

.card-heading h2 {
  margin: 0;
  color: #13213a;
  font-size: 17px;
  font-weight: 700;
}

.card-heading p {
  margin: 3px 0 0;
  color: #8a96a8;
  font-size: 12px;
}

.heading-icon {
  width: 42px;
  height: 42px;
  border-radius: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e7f0ff;
}

.heading-icon .v-icon {
  color: #2468d3;
}

.route-icon {
  background: #e8f8f3;
}

.route-icon .v-icon {
  color: #17a879;
}

.amount-icon {
  background: #fff2df;
}

.amount-icon .v-icon {
  color: #f09523;
}

.field-grid > .flex,
.route-grid > .flex {
  padding: 4px 10px;
}

.checkbox-field {
  display: flex;
  align-items: center;
  padding-top: 13px !important;
}

.option-grid {
  margin-top: 18px;
}

.option-grid > .flex {
  padding: 6px 10px;
}

.option-box {
  height: 100%;
  padding: 14px 17px;
  border: 1px solid #e6ebf3;
  border-radius: 15px;
  background: #fafcff;
}

.receipt-option-box {
  padding: 10px 14px;
}

.receipt-option-box .v-input {
  margin-top: 5px;
  padding-top: 0;
}

.option-title {
  color: #68758a;
  font-size: 12px;
  font-weight: 600;
}

.summary-card {
  position: sticky;
  top: 16px;
}

.total-panel {
  position: relative;
  overflow: hidden;
  margin-bottom: 19px;
  padding: 19px;
  border-radius: 17px;
  color: #fff;
  background: linear-gradient(135deg, #1769d2, #19a2e8);
}

.total-panel:after {
  content: '';
  position: absolute;
  right: -26px;
  bottom: -46px;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}

.total-panel span,
.total-panel small,
.total-panel strong {
  position: relative;
  z-index: 1;
  display: block;
}

.total-panel span {
  font-size: 12px;
  opacity: 0.8;
}

.total-panel strong {
  margin: 3px 0;
  font-size: 29px;
}

.total-panel small {
  opacity: 0.76;
}

.amount-fields > * {
  margin-bottom: 3px;
}

@media (max-width: 700px) {
  .refund-hero {
    margin: 10px 10px 0;
    padding: 20px;
    align-items: flex-start;
    gap: 20px;
    flex-direction: column;
  }

  .refund-hero h1 {
    font-size: 24px;
  }

  .hero-actions {
    width: 100%;
  }

  .primary-action {
    flex: 1;
  }

  .refund-content {
    padding: 8px 2px 18px;
  }

  .modern-card {
    padding: 17px 13px;
    border-radius: 17px;
  }

  .summary-card {
    position: static;
  }
}
</style>